import React, {Component} from 'react';
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import {_Object, _Date} from "react-utils-y";
import {Theme} from 'theme-y';
// import {Theme} from '../../../theme/index';

import {setFormData, delFormData} from '../../actions/index'
import {dateRangeStyle} from './dateRangeStyle';
import {formTypeDom, verifyFn} from './subpage';
import {renderBox, setLocationFn} from '../publicField';

const propTypes = {
    designationTheme: PropTypes.string,
    formType: PropTypes.string,
    inputName: PropTypes.string.isRequired,
    formText: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    hintText: PropTypes.string,
    textWidth: PropTypes.string,
    valueWidth: PropTypes.string,
    changeValue: PropTypes.func,
    errorText: PropTypes.string,
    dataType: PropTypes.string,
    // remarks  无规则 自定义传参
    // regex:PropTypes.number,//正则 input特有
    regexText: PropTypes.string,//input特有
};

const isLeap = (year) => year % 100 == 0 ? (year % 400 == 0 ? 1 : 0) : (year % 4 == 0 ? 1 : 0);

const dateReg = /^(?:(?!0000)[0-9]{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)-02-29)$/;


const formatTen = (num) => {
        return num > 9 ? (num + "") : ("0" + num);
    },
    timesFormat = (a) => {
        return _Date.format(new Date(a), "yyyy-MM-dd")
    },
    returnMinValue = (a, b) => {
        if (!a && !b) return "";
        if (a && b) {
            let minDateTimes = new Date(a).getTime(),
                maxDateTimes = new Date(b).getTime();
            return minDateTimes < maxDateTimes ? timesFormat(minDateTimes) : timesFormat(maxDateTimes);
        } else {
            return a ? a : b
        }
    },
    returnMaxValue = (a, b) => {
        if (!a && !b) return "";
        if (a && b) {
            let minDateTimes = new Date(a).getTime(),
                maxDateTimes = new Date(b).getTime();
            return minDateTimes < maxDateTimes ? timesFormat(maxDateTimes) : timesFormat(minDateTimes);
        } else {
            return a ? a : b
        }
    };


//遍历渲染的日期数据集合
//当月的上月计算
let hiddenDayUp = (year, month, i) => {
        let yearU = month == 1 ? year - 1 : year,
            monthU = month == 1 ? 12 : month - 1,
            datU = [31, 28 + isLeap(yearU), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            monthFirstWeekU = new Date(year + '/' + month + '/' + 1 + " 00:00:00").getDay(),
            dayU = datU[monthU - 1] - (monthFirstWeekU - 1 - i);
        return {
            day: dayU,
            month: monthU,
            year: yearU,
            flag: "up"
        };
    },
    //当月的下月计算
    hiddenDayNext = (year, month, dayNumN) => {
        let monthN = month == 12 ? 1 : month + 1,
            yearN = month == 12 ? year + 1 : year;
        return {
            day: dayNumN,
            month: monthN,
            year: yearN,
            flag: "next"
        };
    };
const setDateData = (_date, _this) => {
    let date = _date,
        year = date.getFullYear(),//2018
        month = date.getMonth() + 1,//0-11   +1
        day = date.getDate(),//1,2,
        monthFirstWeek = new Date(`${year}/${month}/1`).getDay(),//获取这个月分第一天是星期几。 0-6 0是星期日
        monthMaxDay = new Date(year, month, 0).getDate();

    let iNum = (monthMaxDay + monthFirstWeek < 36) ? 35 : 42;
    let listDomDays = iNum == 35 ? [[], [], [], [], []] : [[], [], [], [], [], []],
        thisDay = 0,
        nextDay = 0,
        rows = 0;
    for (let i = 0; i < iNum; i++) {
        rows = parseInt(i / 7);
        //renderType  日期渲染重 星期日开始 还是星期一开始
        let flag = _this.props.renderType == "ch" ? (i + 1) : i;
        if (flag < monthFirstWeek) {//上月
            //需要展示上个月信息 把这个打开
            // listDomDays[rows].push(hiddenDayUp(year, month, i));
            listDomDays[rows].push(0);
            continue
        }
        if (flag >= monthFirstWeek && thisDay < monthMaxDay) {//这个月
            listDomDays[rows].push({
                day: thisDay + 1,
                month: month,
                year: year,
                flag: "now"
            });
            thisDay++;
            continue
        }
        if (flag > parseInt(monthMaxDay + monthFirstWeek) - 1) {//下个月
            //需要展示下个月信息 把这个打开
            // if (monthMaxDay + monthFirstWeek > 35) {
            //     nextDay++;
            //     listDomDays[rows].push(hiddenDayNext(year, month, nextDay));
            // } else {
            //     if (i + 1 > 35) {
            //         listDomDays[rows].push(0)
            //     } else {
            //         nextDay++;
            //         listDomDays[rows].push(hiddenDayNext(year, month, nextDay));
            //     }
            // }
            listDomDays[rows].push(0);
            continue
        }
    }


    //排班 带处理
    if (_this.props.schedule == "1" || _this.props.schedule == "2") {
        let beginDate = listDomDays[0][0].year + "-" + formatTen(listDomDays[0][0].month) + "-" + formatTen(listDomDays[0][0].day);
        let endDate = listDomDays[listDomDays.length - 1][6].year + "-" + formatTen(listDomDays[listDomDays.length - 1][6].month) + "-" + formatTen(listDomDays[listDomDays.length - 1][6].day);
        // _this.setState({
        //     loading: true
        // });
        // _this.getScheduleListFn(beginDate, endDate);
        _this.props.getScheduleFn && _this.props.getScheduleFn(beginDate, endDate);
    }

    return {
        year,
        month,
        day,
        listDomDays
    }
};


class DateRangeField extends Theme {
    constructor(props) {
        super(props);
        let _state = {
            focusState: false,//处理点击的样式
            initFocusState: 0,//是否触发过 0 未触发  1 已经触发
            errorState: false,//是否显示报错提示框，  true  显示报错  false  不显示


            dateOpen: false,

            shouldUpdate: true,//选择年份或者月份滚动分页状态
            showYear: false,//显示年份下拉
            chooseYear: new Date().getFullYear(),//显示选择的年份值
            showMonth: false,//显示月份下拉
            chooseMonth: new Date().getMonth(),//显示选择的月份值

            date: new Date(),//当前日期

            renderDateData: {year: 0, month: 0, day: 0, listDomDays: []},
            //renderDateData2: {year: 0, month: 0, day: 0, listDomDays: []},

            handleDayFlag: true,//单机日期的状态机  第一次开始     第二次结束   第三次清空状态  第四次又开始

            beginDay: "",
            endDay: "",
            beginDayTemp: "",
            endDayTemp: "",
            errorText: '该值不能为空！',

            selLocationH: "bottom",// selLocation:"bottom"  // top  bottom
            selLocationW: "right",// left   right
        };
        this.state = _Object.merge(this.state || {}, _state)
    };

    //年份的下拉滚动条
    initScroll = () => {
        this.setState({shouldUpdate: false});
    };
    //选择年份 月份
    handleHead = (type) => {
        if (type == "year") {
            this.setState({
                showMonth: false,
                showYear: true
            })
        } else {
            this.setState({
                showMonth: true,
                showYear: false
            })
        }

    };
    //移动年份 月份
    moveYear = (value, type) => {
        if (type == "year") {
            this.setState({chooseYear: value})
        } else {
            this.setState({chooseMonth: value})
        }
    };
    //选择年份 月份
    handleYear = (value, type) => {
        if (type == "year") {
            let renderDateData = setDateData(new Date(value + "/01/01"), this);
            let nextYear = renderDateData.month == 12 ? renderDateData.year + 1 : renderDateData.year,
                nextMonth = renderDateData.month == 12 ? 1 : renderDateData.month + 1;

            this.setState({
                showYear: false,
                showMonth: false,
                date: new Date(value + "/01/01"),

                renderDateData: renderDateData,
                //renderDateData2 : setDateData(new Date(nextYear + '/' + nextMonth + '/' + 1), this)
            })
        } else {
            let renderDateData = setDateData(new Date(this.state.date.getFullYear() + "/" + formatTen(value) + "/01"), this);
            let nextYear = renderDateData.month == 12 ? renderDateData.year + 1 : renderDateData.year,
                nextMonth = renderDateData.month == 12 ? 1 : renderDateData.month + 1;

            this.setState({
                showYear: false,
                showMonth: false,
                date: new Date(this.state.date.getFullYear() + "/" + formatTen(value) + "/01"),

                renderDateData: renderDateData,
                // renderDateData2: setDateData(new Date(nextYear + '/' + nextMonth + '/' + 1), this)
            })
        }
    };
    //点旁边关闭下拉
    colseSelest = (year) => {
        this.setState({
            showYear: false,
            showMonth: false
        })
    };

    /*点击显示日期*/
    showDate = (e) => {
        if (this.props.disabled)return;
        this.setState({dateOpen: true});
        let _this = this;
        let formDataValue = _this.props.formData[_this.props.dataType || "default"];
        let inputData = formDataValue && formDataValue[_this.props.inputName];
        let dateValue = inputData && inputData.text ? inputData.text : "";//_this.props.dataObj[_this.props.inputName];

        dateValue = dateValue.replace(/-/g, "/");
        let setDate = _this.props.setDate && _this.props.setDate.replace(/-/g, "/");

        let renderDateData = setDateData(dateValue ? new Date(dateValue.split("至")[0].trim()) : setDate ? new Date(setDate) : new Date(), _this);
        let nextYear = renderDateData.month == 12 ? renderDateData.year + 1 : renderDateData.year,
            nextMonth = renderDateData.month == 12 ? 1 : renderDateData.month + 1;

        _this.setState({
            renderDateData: renderDateData,
            //renderDateData2: setDateData(new Date(nextYear + '/' + nextMonth + '/' + 1), _this)
        });


        setLocationFn(_this, e);
    };
    /*上个月点击*/
    lastMonth = (year, month) => {
        let yearL = month == 1 ? year - 1 : year,
            monthL = month == 1 ? 12 : month - 1;

        let renderDateData = setDateData(new Date(yearL + '/' + monthL + '/' + 1), this);
        let nextYear = renderDateData.month == 12 ? renderDateData.year + 1 : renderDateData.year,
            nextMonth = renderDateData.month == 12 ? 1 : renderDateData.month + 1;

        this.setState({
            date: new Date(yearL + '/' + monthL + '/' + 1),
            renderDateData: renderDateData,
            // renderDateData2: setDateData(new Date(nextYear + '/' + nextMonth + '/' + 1), this)
        })
    };
    /*下个月点击*/
    nextMonth = (year, month) => {
        //如果只是一个日历模块 用此处
        let yearN = month == 12 ? year + 1 : year,
            monthN = month == 12 ? 1 : month + 1;

        // //如果是两个日历模块 用此处
        // let yearN = year,
        //     monthN = month;

        let renderDateData = setDateData(new Date(yearN + '/' + monthN + '/' + 1), this);
        let nextYear = renderDateData.month == 12 ? renderDateData.year + 1 : renderDateData.year,
            nextMonth = renderDateData.month == 12 ? 1 : renderDateData.month + 1;

        this.setState({
            date: new Date(yearN + '/' + monthN + '/' + 1),
            renderDateData: renderDateData,
            // renderDateData2: setDateData(new Date(nextYear + '/' + nextMonth + '/' + 1), this)
        });
    };
    /*选择日期*/
    handleDayOpen = (value) => {
        const {...props} = this.props;
        let day = `${value.year}-${formatTen(value.month)}-${formatTen(value.day)}`,
            /*每一个日历的时间戳*/
            activeDateTimes = new Date(day).getTime(),
            /*获取父组件的minData,maxDate的时间戳*/
            pMinDateTimes = new Date(props.minDate).getTime(),
            pMaxDateTimes = new Date(props.maxDate).getTime();

        /*disabled的日期*/
        if (pMinDateTimes > activeDateTimes || activeDateTimes > pMaxDateTimes) {
            return
        }

        if (this.state.handleDayFlag) {
            this.setState({
                beginDay: day,
                endDay: day
            })
        } else {
            this.setState({
                beginDay: returnMinValue(this.state.beginDay, day),
                endDay: returnMaxValue(this.state.endDay, day),
            })
        }
        this.setState({
            handleDayFlag: !this.state.handleDayFlag,
            chooseFast: "自定义",
        })
    };

    /*清空数据*/
    handleDayClear = () => {
        this.setState({
            beginDay: "",
            beginDayTemp: "",
            endDay: "",
            endDayTemp: "",
        })
    };
    /*输入框change*/
    inputChangeFn = (name, e) => {

        let value = e.target.value;
        if (dateReg.test(value)) {
            /*满足日期正则*/
            this.setState({
                beginDay: returnMinValue(this.state[name], value),
                endDay: returnMaxValue(this.state[name], value),
                date: new Date(returnMinValue(this.state[name], value))
            })
        } else {
            if (name == "endDay") {
                this.setState({
                    beginDay: "",
                    beginDayTemp: value,
                })
            } else {
                this.setState({
                    endDay: "",
                    endDayTemp: value,
                })
            }
        }
    };

    //快捷方式点击
    chooseFastFn = (item) => {
        this.setState({
            chooseFast: item.text,
            beginDay: item.beginDate,
            endDay: item.endDate,
        })
    };

    //下拉点击旁边关闭下拉  设置date值
    handleDayCloseSelect = () => {
        this.setState({dateOpen: false, initFocusState: 1});

        let value = this.state.beginDay == this.state.endDay ?
            this.state.beginDay :
            `${this.state.beginDay} 至 ${this.state.endDay}`;
        // if (value) {
        let bdTime = new Date(this.state.beginDay.replace(/-/g, '/') + " 00:00:00").getTime();
        let edTime = new Date(this.state.endDay.replace(/-/g, '/') + " 00:00:00").getTime();
        let arr = [];
        for (var i = bdTime; i <= edTime; i += 86400000) {
            arr.push(_Date.format(new Date(i), "yyyy-MM-dd"))
        }
        this.setState({
            focusState: false,
            dateOpen: false
        });

        let obj = [{
            type: "dateRange",//type 类型
            name: this.props.inputName,//name input名称
            text: value,//text input值
            value: value,
            obj: {
                beginDate: this.state.beginDay,
                endDate: this.state.endDay,
                arr,
            },
            remarks: this.props.remarks,//备注
            other: {
                required: this.props.required
            }
        }];
        this.props.setFormData(obj, this.props.dataType);
        this.props.changeValue && this.props.changeValue(obj[0]);
        // }
    };
    //返回 关闭弹出框
    handleDayCloseDialog = () => {
        this.setState({dateOpen: false, initFocusState: 1});
    };
    /*数据提交*/
    handleDaySubmit = () => {
        let value = this.state.beginDay == this.state.endDay ?
            this.state.beginDay :
            `${this.state.beginDay} 至 ${this.state.endDay}`;
        // if (value) {
        let bdTime = new Date(this.state.beginDay.replace(/-/g, '/') + " 00:00:00").getTime();
        let edTime = new Date(this.state.endDay.replace(/-/g, '/') + " 00:00:00").getTime();
        let arr = [];
        for (var i = bdTime; i <= edTime; i += 86400000) {
            arr.push(_Date.format(new Date(i), "yyyy-MM-dd"))
        }
        this.setState({
            focusState: false,
            dateOpen: false
        });

        let obj = [{
            type: "dateRange",//type 类型
            name: this.props.inputName,//name input名称
            text: value,//text input值 如：2018-01-01 至 2018-01-23
            value: {
                beginDate: this.state.beginDay,//2018-01-01
                endDate: this.state.endDay,//2018-01-23
            },
            obj: {
                arr,//如： ["2018-01-01","2018-01-02"]
            },
            remarks: this.props.remarks,//备注
            other: {
                required: this.props.required
            }
        }];
        this.props.setFormData(obj, this.props.dataType);
        this.props.changeValue && this.props.changeValue(obj[0]);
        // }
        // this.props.getValue && this.props.getValue("dateFieldRange", this.props.inputName, value, arr);

    };
    /*弹出框关闭*/
    handleDayClose = () => {
        this.setState({
            focusState: false,
            dateOpen: false,
            initFocusState: 1,
        })
    };

    componentWillMount() {
        let props = this.props;
        let flag = "set";
        try {
            //已经存在数据 就不 重新赋值
            flag = props.formData[props.dataType || "default"][props.inputName] ? "none" : "set"
        } catch (ex) {
            flag = "set"
        } finally {
            if (props.inputName && flag == "set") {
                let obj = [{
                    type: "dateRange",//type 类型
                    name: this.props.inputName,//name input名称
                    text: "",//text input值
                    value: "",
                    obj: {},
                    remarks: this.props.remarks,//备注
                    other: {
                        required: this.props.required
                    }
                }];
                props.setFormData(obj, props.dataType);
            }
        }

    }

    componentDidMount() {

    }
    componentWillUnmount() {
        this.props.delFormData(this.props.inputName || "", this.props.dataType)
    }
    render() {
        return renderBox(this, dateRangeStyle, formTypeDom, verifyFn)
    }
}

DateRangeField.propTypes = propTypes;

const mapStateToProps = state => {
    return {
        formData: state.formData,
        subVerifyRes: state.subVerifyRes,
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({
    setFormData: (data, dataType) => dispatch(setFormData(data, dataType)),
    delFormData: (inputName, dataType) => dispatch(delFormData(inputName, dataType))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DateRangeField)

